.room {
  --mobile-edge: #251308;
  background: radial-gradient(
    ellipse at 50% 45%,
    #342116 0%,
    #1a110b 44%,
    #0b0705 74%,
    #030201 100%
  );
}

.room .scene::after {
  content: '';
  position: absolute;
  z-index: 2;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(circle at 47% 70%, rgba(244, 147, 49, 0.055), transparent 34%);
}

.room .scene {
  transform-origin: 32% 70%;
  transition: transform 0.52s steps(9, end);
}

.room .sceneFocused {
  transform: scale(1.69);
}

.sourceNotebook {
  position: absolute;
  z-index: 10;
  left: 77%;
  top: 81%;
  width: 20cqw;
  height: auto;
  transform: translate(-50%, -50%) rotate(-3deg);
  filter: drop-shadow(0.45cqw 0.55cqw 0 rgba(15, 6, 2, 0.48));
  image-rendering: pixelated;
  pointer-events: none;
}

.sourceComputer {
  position: absolute;
  z-index: 7;
  left: 38%;
  bottom: 1.5%;
  width: 43cqw;
  transform: translateX(-50%) translateY(1.2cqw);
  transform-origin: 50% 38%;
  transition:
    transform 0.48s steps(8, end),
    filter 0.18s;
  filter: drop-shadow(1.2cqw 1.6cqw 0 rgba(18, 7, 3, 0.48));
  image-rendering: pixelated;
}

.roomActive .sourceComputer {
  transform: translateX(-50%) translateY(0);
}
.roomActive .sourceComputerFocused {
  z-index: 9;
  transform: translateX(-50%) translateY(0);
  transform-origin: 50% 38%;
  filter: brightness(1.04) drop-shadow(1.2cqw 1.6cqw 0 rgba(18, 7, 3, 0.52));
}

.sourceComputer::after {
  content: '';
  position: absolute;
  z-index: 3;
  left: 14.5%;
  top: 19.3%;
  width: 64.5%;
  height: 42.5%;
  pointer-events: none;
  box-shadow:
    0 0 1.7cqw rgba(99, 238, 102, 0.25),
    inset 0 0 1.8cqw rgba(99, 238, 102, 0.1);
}

.sourceComputer > img {
  position: relative;
  z-index: 1;
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
}

.computerTrigger {
  position: absolute;
  z-index: 2;
  inset: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  background: transparent;
  cursor: pointer;
}

.sourceComputer:has(.computerTrigger:hover),
.sourceComputer:has(.computerTrigger:focus-visible) {
  filter: brightness(1.06) drop-shadow(1.2cqw 1.6cqw 0 rgba(18, 7, 3, 0.48));
}
.computerTrigger:focus-visible {
  outline: 0;
}

.sourceTerminal {
  position: absolute;
  z-index: 4;
  top: 17%;
  left: 15.5%;
  width: 64.5%;
  height: 47.5%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 1.45cqw 1.8cqw 1.7cqw;
  clip-path: polygon(1% 2%, 99% 2%, 99% 98%, 1% 98%);
  color: #8fe777;
  background: rgba(1, 9, 4, 0.8);
  text-shadow: 0 0 0.6cqw rgba(113, 220, 91, 0.55);
  container-type: inline-size;
  pointer-events: none;
  transform: none;
  transform-origin: 50% 50%;
  transition:
    transform 0.48s steps(8, end),
    filter 0.18s,
    box-shadow 0.18s;
  animation: sourceBoot 0.42s steps(5, end) both;
}

.sourceTerminal::after {
  content: '';
  position: absolute;
  z-index: 8;
  inset: 0;
  pointer-events: none;
  opacity: 0.16;
  background: repeating-linear-gradient(0deg, transparent 0 3px, #73d95b 4px);
}

.sourceTabs {
  position: relative;
  z-index: 10;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.8cqw;
  margin-bottom: 1.2cqw;
  padding-bottom: 1cqw;
  border-bottom: 0.45cqw solid #2e6333;
  pointer-events: auto;
}

.sourceTabs button {
  min-width: 0;
  padding: 0.8cqw 0.6cqw;
  border: 0.45cqw solid #315c35;
  color: #527d53;
  background: #071309;
  font: inherit;
  font-size: clamp(3px, 1.45cqw, 6px);
  text-align: left;
  cursor: pointer;
}

.sourceTabs button:hover,
.sourceTabs button:focus-visible,
.sourceTabs .sourceTabActive {
  border-color: #8fe777;
  color: #c8ffae;
  background: #123019;
  outline: 0;
}

.terminalPanel,
.phishTerminal {
  position: relative;
  z-index: 2;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  animation: terminalTune 0.3s steps(4, end) both;
}

.sourceTerminal header {
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.5cqw;
  border-bottom: 0.7cqw solid #3d8340;
  font-size: clamp(3px, 2.2cqw, 8px);
}

.sourceTerminal header span {
  color: #47764b;
}
.sourceTerminal p {
  margin: 1.5cqw 0;
  color: #568b57;
  font-size: clamp(3px, 1.6cqw, 6px);
  line-height: 1.5;
}
.sourceTerminal small {
  color: #4d784f;
  font-size: clamp(3px, 1.45cqw, 5px);
  line-height: 1.6;
}

.sourceTerminal a {
  width: max-content;
  margin-top: auto;
  padding: 1.25cqw 1.65cqw;
  border: 0.55cqw solid #69bc5c;
  color: #bafa9e;
  background: #0b2811;
  font-size: clamp(4px, 1.85cqw, 7px);
  pointer-events: auto;
}

.sourceTerminal a:hover,
.sourceTerminal a:focus-visible {
  color: #071108;
  background: #99ee7b;
  outline: 0;
  text-shadow: none;
}

.agentPipeline {
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin: 1.4cqw 0 2.1cqw;
}

.agentPipeline::after {
  content: '';
  position: absolute;
  z-index: 3;
  left: 4%;
  top: 1.1cqw;
  width: 1.5cqw;
  aspect-ratio: 1;
  background: #d4ffae;
  box-shadow: 0 0 1.2cqw #80e66c;
  animation: agentTravel 3.2s steps(16, end) infinite;
}

.agentPipeline > div {
  position: relative;
  display: grid;
  justify-items: center;
  gap: 1cqw;
  color: #4f7e50;
  font-size: clamp(2px, 1.25cqw, 5px);
}

.agentPipeline > div:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 58%;
  top: 1.55cqw;
  width: 84%;
  height: 0.45cqw;
  background: #27572f;
}

.agentPipeline i {
  position: relative;
  z-index: 2;
  width: 3.4cqw;
  aspect-ratio: 1;
  border: 0.55cqw solid #4d9950;
  background: #0a1a0c;
  box-shadow: inset 0 0 0 0.5cqw #16361d;
  animation: agentNode 3.2s steps(1, end) var(--agent-delay) infinite;
}

.phishTerminal > strong {
  color: #d6f7a5;
  font-size: clamp(3px, 2cqw, 7px);
}

.campaignFlow {
  display: grid;
  gap: 1cqw;
  margin: 1.6cqw 0;
}

.campaignFlow span {
  display: grid;
  grid-template-columns: 1fr 2.2fr;
  align-items: center;
  gap: 1.2cqw;
  color: #5c925b;
  font-size: clamp(2px, 1.25cqw, 5px);
}

.campaignFlow i {
  display: block;
  width: 0;
  height: 0.8cqw;
  background: repeating-linear-gradient(90deg, #76dd62 0 1.8cqw, #285f30 1.8cqw 2.2cqw);
  animation: campaignLoad 0.8s steps(8, end) var(--flow-delay) forwards;
}

.mailStack {
  position: absolute;
  z-index: 5;
  left: 74%;
  top: 70%;
  width: 25cqw;
  height: auto;
  transform: translate(-50%, -50%) rotate(1deg);
  filter: drop-shadow(0.8cqw 1cqw 0 rgba(20, 7, 2, 0.4));
  pointer-events: none;
  image-rendering: pixelated;
}

.mailDecoration {
  position: absolute;
  z-index: 8;
  height: auto;
  transform: translate(-50%, -50%) rotate(var(--mail-rotate));
  transform-origin: center;
  filter: drop-shadow(0.55cqw 0.7cqw 0 rgba(20, 7, 2, 0.4));
  pointer-events: none;
  image-rendering: pixelated;
}

.mailPhish {
  --mail-rotate: -4deg;
  left: 78%;
  top: 69%;
  width: 18cqw;
}
.mailSpam {
  --mail-rotate: 7deg;
  left: 87%;
  top: 80%;
  width: 15cqw;
}

.sourceHint {
  position: absolute;
  z-index: 14;
  inset: 0;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.18s steps(2, end);
}

.sourceHintVisible {
  opacity: 1;
}

.sourceHint span {
  position: absolute;
  display: block;
  padding: 0.8cqw 1.05cqw;
  border: 0.2cqw solid #e6d797;
  color: #e6d797;
  background: rgba(6, 9, 8, 0.94);
  box-shadow: 0.45cqw 0.45cqw 0 #020303;
  font-size: clamp(4px, 0.65cqw, 9px);
  line-height: 1.7;
  text-align: center;
  white-space: nowrap;
  animation: sourceCallout 1s steps(2, end) infinite;
}

.sourceHint span::after {
  content: '';
  position: absolute;
  top: 100%;
  width: 0;
  height: 0;
  border: 0.75cqw solid transparent;
  border-top-color: #e6d797;
}

.sourceHint b {
  color: #8fe777;
}
.computerCallout {
  left: 25%;
  top: 29%;
  transform: rotate(-1deg);
}
.computerCallout::after {
  left: 62%;
}

.room:not(.roomActive) .sourceTerminal *,
.room:not(.roomActive) .sourceTerminal {
  animation-play-state: paused;
}

@keyframes sourceBoot {
  0% {
    opacity: 0;
    scale: 1 0.02;
  }
  55% {
    opacity: 1;
    scale: 1 0.02;
  }
  100% {
    scale: 1 1;
  }
}
@keyframes terminalTune {
  0% {
    opacity: 0.1;
    translate: -8% 0;
  }
  45% {
    opacity: 0.45;
    translate: 4% 0;
  }
  100% {
    opacity: 1;
    translate: 0;
  }
}
@keyframes agentTravel {
  0%,
  8% {
    translate: 0 0;
    opacity: 0;
  }
  12% {
    opacity: 1;
  }
  86% {
    opacity: 1;
  }
  92%,
  100% {
    translate: 25.5cqw 0;
    opacity: 0;
  }
}
@keyframes agentNode {
  0%,
  18%,
  100% {
    border-color: #4d9950;
    filter: none;
  }
  20%,
  44% {
    border-color: #cfffad;
    filter: brightness(1.35);
  }
  46% {
    border-color: #4d9950;
    filter: none;
  }
}
@keyframes campaignLoad {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
@keyframes sourceCallout {
  50% {
    translate: 0 -0.35cqw;
  }
}

@media (max-width: 680px) {
  .sourceComputer {
    left: 50%;
    bottom: 31.5%;
    width: 54cqw;
    transform: translateX(-50%) translateY(1.2cqw);
  }
  .room .scene {
    transform-origin: 48% 40%;
  }
  .room .sceneFocused {
    transform: scale(2.05);
  }
  .roomActive .sourceComputer {
    transform: translateX(-50%) translateY(0);
  }
  .roomActive .sourceComputerFocused {
    transform: translateX(-50%) translateY(0);
    transform-origin: 50% 38%;
  }
  .sourceNotebook {
    left: 47%;
    top: 72%;
    width: 29cqw;
  }
  .sourceTerminal {
    padding: 1.9cqw 2.3cqw;
  }
  .sourceTabs {
    gap: 1.1cqw;
    margin-bottom: 1.4cqw;
  }
  .sourceTabs button {
    padding: 1.1cqw 0.8cqw;
  }
  .sourceTerminal p {
    margin-block: 1.2cqw;
  }
  .agentPipeline {
    margin-block: 1.2cqw 1.6cqw;
  }
  .campaignFlow {
    gap: 0.65cqw;
    margin-block: 1cqw;
  }
  .mailStack {
    left: 52%;
    top: 69%;
    width: 36cqw;
  }
  .mailPhish {
    left: 45%;
    top: 68%;
    width: 25cqw;
  }
  .mailSpam {
    left: 66%;
    top: 74%;
    width: 21cqw;
  }
  .roomActive .sourceComputerFocused {
    z-index: 7;
  }
  .sourceHint span {
    padding: 1.4cqw 1.8cqw;
    border-width: 0.35cqw;
    font-size: clamp(4px, 1.15cqw, 7px);
  }
  .sourceHint span::after {
    border-width: 1.2cqw;
  }
  .computerCallout {
    left: 24%;
    top: 43%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .sourceTerminal,
  .sourceTerminal * {
    animation-duration: 0.01ms;
    animation-iteration-count: 1;
  }
  .sourceComputer,
  .scene {
    transition-duration: 0.01ms;
  }
}
